export default {
  /* common mutations */

  syncState(state, newState) {
    state.headers = [...newState.headers]
    state.posts = newState.posts || []
  },

  /* specific mutations */

  setPosts(state, posts) {
    state.posts = [...posts]
  },

  setPost(state, post) {
    // check if the post is already in the state
    const postId = post.id
    const index = state.posts.findIndex((p) => p.id === postId)

    index < 0
      ? state.posts.push(post) // append
      : state.posts.splice(index, 1, post) // replace
  },

  setHeaders(state, headers) {
    state.headers = headers
  },

  setFetched(state, isFetched) {
    state.fetched = isFetched
  },

  setLoading(state, { loading, promise = null }) {
    state.loading = loading
    state.promise = promise
  }
}
